function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase, { LARGE_VIEWBOX } from '../shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function SocialFacebookColorIcon(props) {
  return ___EmotionJSX(IconBase, _extends({
    width: "32",
    height: "32",
    viewBox: LARGE_VIEWBOX
  }, props), ___EmotionJSX("path", {
    d: "M16.0698 2.66675C8.66835 2.66675 2.66797 8.66713 2.66797 16.0686C2.66797 22.7878 7.61752 28.3356 14.0669 29.3048V19.6207H10.7511V16.0979H14.0669V13.7537C14.0669 9.87269 15.9577 8.16882 19.1833 8.16882C20.7282 8.16882 21.5451 8.28335 21.9319 8.33574V11.4109H19.7316C18.3622 11.4109 17.884 12.709 17.884 14.1722V16.0979H21.8972L21.3526 19.6207H17.884V29.3334C24.4253 28.4458 29.4717 22.853 29.4717 16.0686C29.4717 8.66713 23.4713 2.66675 16.0698 2.66675Z",
    fill: "#1877F2"
  }));
}